import React, { useState, useRef } from "react";
import { graphql, } from "gatsby"
import Flink from '~/components/shared/flink'
import { Seo } from '~/components/shared/seo'
import { notBlank, imgSize } from '~/utils/helpers'

import * as styles from "~/styles/blog/blog-home.module.scss"
import { aria_btn, cta_link } from "~/styles/app.module.scss"

const Blog = ({ data: { blog } }) => {
  const posts = blog.data.posts
  const featured = posts.find( x => x.featured )
  const not_feat = posts.filter( x => !x.featured )

  const [currType, setCurrType] = useState('all')
  const [list, setList] = useState(not_feat)

  const listRef = useRef(null)

  
  let menu_items = ['all']
  menu_items = menu_items.concat([...new Set(posts.map(x => x.category))]).sort()

  const post_link = (handle) => {
    return handle !== 'buck-mason-knitting-mills' ? `/blogs/journal/${handle}` : '/pages/buck-mason-knitting-mills'
  }

  const handle_type = (type) => {
    const new_list = type === 'all' ? not_feat : not_feat.filter(x => x.category === type)
    setCurrType(type)
    setList(new_list)

    const list_top = listRef.current.getBoundingClientRect().top
    const list_pos = (list_top + window.pageYOffset) - 120
    window.scrollTo({
      top: list_pos,
      behavior: 'smooth'
    })
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.blog}>
        <div className={styles.hero}>
          <div className={styles.hero_content}>
            <div className={styles.hero_copy}>
              <Flink href={post_link(featured.handle)} className={styles.title}>
                {featured.title}
              </Flink>
              {featured.excerpt && (
                <div className={styles.blurb}>
                  {featured.excerpt}
                </div>
              )}
              <div className={styles.hero_ctas}>
                <Flink href={post_link(featured.handle)} className={cta_link}>
                  <span className={''}>Read More</span>
                </Flink>
              </div>
            </div>
          </div>
          <div className={styles.image}>
            <Flink href={post_link(featured.handle)}>
              {notBlank(featured.image) && (
                <img className={styles.img} src={imgSize(featured.image,900)} width="900" height="800" alt="" />
              )}
            </Flink>
          </div>
        </div>
      </div>
      <div className={styles.bar}>
        <div className={styles.bar_cont}>
          {menu_items.map(x => 
            <button
              type="button"
              key={x}
              className={`${aria_btn} ${styles.bar_item} ${x === currType ? styles.curr : ''}`} 
              onClick={(e)=> handle_type(x)}
            >
              {x}
            </button>
          )}
        </div>
      </div>
      <div className={styles.blog_cont} ref={listRef}>
        <div className={styles.list}>
          {list && list.map( (post, index) =>
            <Flink 
              key={`${post.handle}-${index}`} 
              href={post_link(post.handle)}
              className={styles.item}
            >
              <div className={styles.image}>
                {notBlank(post.image) && (
                  <img 
                    className={styles.img} 
                    src={imgSize(post.image,600)} 
                    width="900" 
                    height="800" 
                    alt={post.title}
                  />
                )}
              </div>
              <div className={styles.content}>
                <div className={styles.title}>
                  <div className={styles.text}>
                    {post.title}
                  </div>
                </div>
                {post.excerpt && (
                  <div className={styles.blurb}>
                    {post.excerpt}
                  </div>
                )}
              </div>
            </Flink>
          )}
        </div>
      </div>
    </div>
  )
}
export default Blog


export const Head = ({ data: { blog } }) => (
  <Seo 
    title={'Journal'}
    description={'The Buck Mason Journal'}
    image={blog.image}
    url={`/blogs/journal`}
  />
)


export const pageQuery = graphql`
  {
    blog: contentPage(type: {eq: "Blog"}) {
      handle
      data
    }
  }
`;
